import { createFileRoute, redirect } from '@tanstack/react-router';
import { PaginaLegal } from '../features/legal/components/paginaLegal';
import { esSlugDocumentoLegal } from '../features/legal/documentos';

/**
 * `/legal/$documento` (P-01): un documento legal completo. Anida bajo `routes/legal.tsx` (ver su
 * JSDoc) por la convención de rutas planas de TanStack Router — el nombre de este fichero empieza
 * por `legal.`. Pública y sin guarda, igual que su padre.
 *
 * `beforeLoad` valida el segmento contra los cinco `slug` conocidos (`esSlugDocumentoLegal`,
 * `features/legal/documentos.ts`) y redirige a `/legal` si no es ninguno de los cinco — mismo
 * patrón que `routes/index.tsx` (`redirect` dentro de `beforeLoad` cuando la comprobación previa
 * falla), en vez de montar una pantalla de "no encontrado" nueva, fuera de la lista de ficheros
 * permitidos de esta tarea.
 */
export const Route = createFileRoute('/legal/$documento')({
	beforeLoad: ({ params }) => {
		if (!esSlugDocumentoLegal(params.documento)) {
			throw redirect({ to: '/legal' });
		}
	},
	component: PantallaDocumentoLegal,
});

function PantallaDocumentoLegal(): React.JSX.Element {
	const { documento } = Route.useParams();
	if (!esSlugDocumentoLegal(documento)) {
		// Inalcanzable: `beforeLoad` ya redirige a `/legal` antes de llegar aquí si el segmento no
		// es uno de los cinco `slug` conocidos. La comprobación se repite para que TypeScript
		// estreche `documento` de `string` a `DocumentoLegalSlug` sin recurrir a un aserto de tipo.
		throw new Error(`Documento legal desconocido: ${documento}`);
	}
	return <PaginaLegal documento={documento} />;
}
